<!--供应商审核-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="企业名称">
            <a-input v-decorator="['name']" placeholder="请输入企业名称"></a-input>
          </a-form-item>
          <a-form-item label="供应商类型">
            <a-select
              class="form-control"
              :options="typesMap.businessTypeList"
              v-decorator="['businessType']"
              placeholder="请选择"
              showSearch
              :filterOption="filterByPY$t"
            ></a-select>
          </a-form-item>
          <a-form-item label="状态">
            <a-select
              class="form-control"
              :options="typesMap.kuaiqianAuditStatus"
              v-decorator="['kuaiqianAuditStatus']"
              placeholder="请选择"
              showSearch
              :filterOption="filterByPY$t"
            ></a-select>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">供应商审核列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" type="primary" @click="addSupplier">
          <app-icon type="icon-tianjia"></app-icon>
          创建供应商
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="useRowIndex"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        >
          <!-- 操作列 -->
          <template slot="handler" slot-scope="text, row">
            <div class="flex gap-1 justify-center text-primary-500">
              <a-button type="link" size="small" @click=" addSupplierUser(row)">
                子账号管理
              </a-button>
              <a-button type="link" size="small" @click="enableDisable(row)">
                {{ row.companyStatus == 0 ? '禁用' : '启用' }}
              </a-button>
              <a-button type="link" size="small" @click="checkRow(row)">查看</a-button>
              <a-button type="link" size="small" @click="editRow(row)">编辑</a-button>
            </div>
          </template>
        </a-table>
      </div>

      <a-modal v-model="modal.visible" :title="`审核信息`">
        <div class="relative">
          <a-form labelAlign="left" :labelCol="{ span: 5 }" class="form">
            <a-form-item label="审核日期">
              <span>{{ modal.data.auditTime }}</span>
            </a-form-item>
            <a-form-item label="审核人员">
              <span>{{ modal.data.auditUserName }}</span>
            </a-form-item>
          </a-form>
        </div>
        <template v-slot:footer>
          <a-button type="primary" @click="handleOk">确定</a-button>
        </template>
      </a-modal>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import fileDownload from 'js-file-download'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '60px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '企业名称',
        align: 'center',
        dataIndex: 'companyName',
      },
      {
        title: '供应商类型',
        width: '120px',
        align: 'center',
        dataIndex: 'businessType',
      },
      {
        title: '联系人',
        width: '80px',
        align: 'center',
        dataIndex: 'contactName',
      },
      {
        title: '联系电话',
        width: '140px',
        align: 'center',
        dataIndex: 'contactPhone',
      },
      {
        title: '创建日期',
        width: '180px',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '快钱审核状态',
        width: '120px',
        align: 'center',
        dataIndex: 'kuaiqianAuditStatus',
        customRender: (text, row, index) => {
          return (
            <div>
              <span
              // onclick={() => {
              //   this.openModal(row)
              // }}
              >
                {this.translateType$t(text, 'kuaiqianStatus')}
              </span>
            </div>
          )
        },
      },
      {
        title: '操作',
        align: 'center',
        dataIndex: 'detail',
        scopedSlots: {
          customRender: 'handler',
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        data: {},
      },
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        kuaiqianStatus: [
          { value: 'UPLOADING', label: '提交中' },
          { value: 'AUDITING', label: '审核中' },
          { value: 'REJECTED', label: '审批拒绝' },
          { value: 'TO_BE_SIGNED', label: '合同待签约' },
          { value: 'FINISHED', label: '已完成' },
        ],
        businessTypeList: [
          { value: 1, label: '签证业务' },
          { value: 2, label: '公证业务' },
          { value: 3, label: '认证业务' },
          { value: 4, label: '旅游业务' },
        ],
      }
    },
  },
  methods: {
    addSupplierUser(row) {
      this.$router.push({
        path: '/m/scopeMain/merchantAudit/childAccount',
        query: {
          supplierId: row.supplierId,
        },
      })
    },
    enableDisable(row) {
      this.$axios
        .put(`/user/admin/supplier/status?supplierId=${row.supplierId}&status=${row.companyStatus == 0 ? 10 : 0}`)
        .then(res => {
          if (res.success) {
            this.$message.success('操作成功')
            this.doQuery()
          }
        })
    },
    addSupplier() {
      this.$router.push({
        path: '/m/scopeMain/merchantAudit/merchantAuditDetail',
        query: {
          type: 'ADD',
        },
      })
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/user/admin/supplier', {
          params: {
            ...this.form.getFieldsValue(),
            page: _pageNumber,
            limit: _pageSize,
          },
        })
        this.countTotal = Number(res.count)
        this.pageSize = _pageSize
        this.pageNumber = _pageNumber
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    transformAdvantage(text) {
      let result = ''
      try {
        const list = JSON.parse(text)

        list.map((item, index) => {
          const separetor = index === 0 ? '' : ','
          result += separetor + item.label
        })
      } catch (e) {}
      return result
    },
    checkRow(row) {
      this.$router.push({
        path: `/m/scopeMain/merchantAudit/merchantAuditDetail`,
        query: {
          supplierId: row.supplierId,
          type: 'DETAIL',
        },
      })
    },
    editRow(row) {
      this.$router.push({
        path: '/m/scopeMain/merchantAudit/merchantAuditDetail',
        query: {
          supplierId: row.supplierId,
          type: 'EDIT',
        },
      })
    },
    openModal(row) {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.data = row
    },
    handleCancel() {
      this.modal.visible = false
    },
    async handleOk() {
      this.modal.visible = false
      if (this.modal.data.auditStatus === 2) {
        const res = await this.$axios.get('/company/admin/area/supplier/queryByCompanyId', {
          params: {
            companyId: this.modal.data.companyId,
          },
        })
        const proxyInfo = res.data
        const title = `${this.modal.data.name}代理领区`
        const content = (
          <div>
            <a-table
              class="origin-style info-table"
              dataSource={proxyInfo}
              rowKey={this.useRowIndex}
              pagination={false}
              bordered
            >
              <a-table-column
                title="序号"
                width="15%"
                align="center"
                scopedSlots={{
                  default: (text, row, index) => {
                    return index + 1
                  },
                }}
              ></a-table-column>
              <a-table-column title="制签国家" dataIndex="countryName" align="center"></a-table-column>
              <a-table-column
                title="代理领区"
                align="center"
                scopedSlots={{
                  default: (text, row) => {
                    return row.areaList ? row.areaList.map(item => item.areaName).join('、') : ''
                  },
                }}
              ></a-table-column>
            </a-table>
          </div>
        )
        await this.$modal({
          title,
          content,
        })
      }
    },
  },
  mounted() {
    this.doQuery()
  },
}
</script>

<style lang="less" scoped>
.audit-status-img {
  width: 105px;
  height: 105px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
</style>
